<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Live Stream Webinars In Your Members Area with Platforma</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Live stream from your own domain without limits and without monteization limits."
      />
    </Head>
  </div>
  <!-- content start -->

  <div
    class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
  >
    <!-- ===================== HERO SECTION ===================== -->

    <section
      id="section1"
      class="hero-section relative mx-auto mt-[150px] justify-center gap-1 bg-transparent lg:flex lg:py-0"
      :style="backgroundImageStyleMain"
    >
      <div class="mt-0 bg-transparent px-[25px] xl:px-0">
        <h1
          class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Go live now and sell more via webinar or stream.
        </h1>

        <p
          class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
        >
          Speak to audiences with ZERO filter. No transaction fees or community
          guidelines. Except the ones you create.
        </p>

        <!-- captcher email widget -->
        <!-- captcher email widget -->
        <EmailCaptureHeaderWidget />

        <img :src="$filters.media_path('/images/stars.svg')" alt="" />
      </div>

      <div class="mb-[30px] mt-[30px] lg:mt-0 z-10 px-[15px]">
        <video
          class="lg:max-w-[618px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
          id="home_video"
          loop
          muted
          autoplay
          playsinline
        >
          <source
            :src="
              $filters.media_path(
                '/videos/live-stream-in-your-course-membership-site-com.mp4'
              )
            "
            type="video/mp4"
          />
        </video>
      </div>
    </section>

    <div
      class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[150px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
    >
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      <h2
        class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
      >
        JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
      </h2>
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
    </div>

    <!-- ===================== EXCLUSIVE CONTENT SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:flex lg:h-[500px] xl:px-0"
    >
      <img
        class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
        :src="$filters.media_path('/images/blue_gradient.svg')"
        alt=""
      />

      <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
        <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
          <div
            id="text_exclusive_content"
            class="text-xs font-extrabold text-[#2D8CFF]"
          >
            EXCLUSIVE CONTENT
          </div>

          <h2
            class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Run Private Member-Only Webinars.
          </h2>

          <hr
            class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
          />

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            No need for outside services or links. Members simply log in to
            their account, and can participate in the stream. Super easy.
          </p>
        </div>

        <div class="z-30 mt-[25px] xl:mt-0">
          <img
            loading="lazy"
            class="lg:w-[650px]"
            :src="
              $filters.media_path(
                '/images/sell-through-webinars-to-your-community.png'
              )
            "
            alt="Creator UI of streaming webinars within Platforma."
          />
        </div>
      </div>
    </section>

    <!-- ===================== PRE-SALES SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[200px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
    >
      <img
        class="absolute top-0 right-[600px] z-0 h-[600px] w-[810px] origin-top-left overflow-hidden"
        :src="$filters.media_path('/images/green-diamond-dots-bg.svg')"
        alt=""
      />

      <div
        class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
      >
        <div
          id="text_sales"
          class="text-xs font-extrabold text-[#27AE60] lg:left-0"
        >
          PRE-SALES
        </div>

        <h2
          class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Registration Page for upcoming Live Streams.
        </h2>

        <div class="">
          <hr
            class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#27AE60] lg:ml-0"
          />
        </div>

        <p
          class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
        >
          Display all upcoming streams on one convenient page inside your
          community and members can register with one click.
        </p>
      </div>

      <div
        class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
      >
        <img
          loading="lazy"
          class="lg:w-[675px]"
          :src="
            $filters.media_path(
              '/images/membership-site-for-courses-for-poker.png'
            )
          "
          alt="Private Platform to sell anything through live streaming events."
        />
      </div>
    </section>
  </div>

  <!--  FEATURES TABS START -->

  <FeaturesTabsWebinars />

  <!--  TWO CARDS START -->

  <TwoCards />

  <!-- ============= EMAIL INTEGRATIONS ============= -->

  <EmailIntegrationsSlider />

  <!-- ===================== CTA BLOCK ===================== -->
  <CtaBlock
    cta-headline="Seamlessly Move Twitch & Youtube
viewers to your site."
  />
</template>

<!-- =======CONTENT END======== -->

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import EmailIntegrationsSlider from '../Components/EmailIntegrationsSlider.vue';
import FeaturesTabsWebinars from '../Components/FeaturesTabs10MaxWebinars.vue';
import TwoCards from '../Components/TwoCardsOneDivWebinars.vue';
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';

export default {
  layout: DefaultLayout,
  components: {
    ButtonComponent,
    EmailCaptureHeaderWidget,
    EmailIntegrationsSlider,
    FeaturesTabsWebinars,
    TwoCards,
    CtaBlock
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}
</style>
